import React from "react";

const Loading = () => {
  return <>Ucitavanje...</>;
};

export default Loading;
